import { CloseButton, Modal, ScrollArea } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../elements/Button';
import GuideBox from '../../elements/GuideBox';
import ChangeUserRoleForm from '../../forms/ChangeUserRoleForm';
import UserForm from '../../forms/UserForm';
import styles from './styles.scoped.css';
import LoadingBars from '../../elements/LoadingBars';
import IcUser from '../../icons/IcUser';
import GridCell from '../../elements/GridCell';
import UserEditForm from '../../forms/UserEditForm';
export default function ModalUser({
  values,
  handleSubmit,
  onClose,
  handleSuspendUser,
  open,
  type,
  data,
  isLoading,
}) {
  const content = {
    'add-user': {
      title: <h6>Form Tambah User Baru</h6>,
      guide: (
        <p>
          Berikut ini adalah form yang digunakan untuk menambah data{' '}
          <strong>User</strong>. Pastikan data yang anda inputkan sudah sesuai.
          Semua parameter pada <strong>form ini bersifat wajib</strong>
        </p>
      ),
      form: <UserForm handleSubmit={handleSubmit} />,
    },
    'edit-user': {
      title: <h6>Form Ubah Data User</h6>,
      guide: (
        <p>
          Berikut ini adalah form yang digunakan untuk merubah data{' '}
          <strong>User</strong>. Pastikan data yang anda inputkan sudah sesuai.
          Semua parameter pada <strong>form ini bersifat wajib</strong>
        </p>
      ),
      form: (
        <UserEditForm
          handleSubmit={handleSubmit}
          initialValues={{ ...values, password: '' }}
          type="update"
        />
      ),
    },
    'change-role': {
      title: <h6>Ubah User Role</h6>,
      guide: (
        <p>
          Berikut ini adalah form yang digunakan untuk merubah data{' '}
          <strong>User Role</strong>. Pastikan data yang anda inputkan sudah
          sesuai. Semua parameter pada <strong>form ini bersifat wajib</strong>
        </p>
      ),
      form: (
        <div>
          {data && (
            <div className={styles.contentDetail}>
              <div>
                <IcUser />
                <span className={styles.label}>{data.name}</span>
              </div>
              <div>
                <GridCell data={data.email} label="Email" />
                <GridCell data={data.regionalName} label="Region" />
                <GridCell data={data.sbmName} label="SAM" />
                <GridCell data={data.samName} label="SAM" />
                <GridCell data={data.roleName} label="Role" />
              </div>
            </div>
          )}
          <ChangeUserRoleForm
            handleSubmit={handleSubmit}
            initialValues={values}
          />
        </div>
      ),
    },
    'block-user': {
      title: <h4>{data?.isActive ? 'Blok User' : 'Aktifkan User'}</h4>,
      content: (
        <p>
          {data?.isActive
            ? 'User yang diblok tidak dapat melakukan login. Apakah Anda yakin untuk memblok user?'
            : 'User yang telah aktif kembali dapat melakukan login. Apakah Anda yakin untuk mengaktifkan user?'}
        </p>
      ),
      form: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Batal</Button>
          <Button
            disabled={isLoading}
            onClick={handleSuspendUser}
            style={data?.isActive ? 'danger' : 'success'}
          >
            {isLoading && <LoadingBars size={1} />}
            {data?.isActive ? 'Blok User' : 'Aktifkan User'}
          </Button>
        </div>
      ),
    },
  };

  return (
    <Modal
      centered
      onClose={onClose}
      opened={open}
      scrollAreaComponent={ScrollArea.Autosize}
      size={'lg'}
      withCloseButton={false}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>
          {content[type]?.title}
          <span onClick={onClose}>
            <CloseButton />
          </span>
        </div>
        {content[type]?.guide && <GuideBox>{content[type]?.guide}</GuideBox>}
        <div>{content[type]?.content}</div>
        {content[type]?.form}
      </div>
    </Modal>
  );
}

ModalUser.propTypes = {
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleSuspendUser: PropTypes.func,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  type: PropTypes.oneOf([
    'add-user',
    'edit-user',
    'change-role',
    'change-password',
  ]),
  values: PropTypes.object,
};
